import { createAsyncThunk } from '@reduxjs/toolkit';

import { BreedingService } from '../../services';

export const createManyBreeding = createAsyncThunk(
  'breedingSlice/createManyBreeding',
  async (data, { rejectWithValue }) => {
    try {
      const response = await BreedingService.createBreedings(data);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to create many breeding.');
    }
  }
);

export const updateBreeding = createAsyncThunk(
  'breedingSlice/updateBreeding',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await BreedingService.updateBreeding({ id, data });

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to update breeding.');
    }
  }
);
